// Robot Development Config
const config = {
  API_BASE_URL: "https://apistaging.international-robotchallenge.org",
  REG_LINK:
    "https://registrationstaging.international-robotchallenge.org?automaticLogin=true",
  APP_ENV: "development",
  APP_NAME: "Robot Reg",
  DEFAULT_LANGUAGE: "en",
  PRIMARY_COLOR: "#7c0707",
  SECONDARY_COLOR: "#fff",
};

// Robot Production Config
// const config = {
//   API_BASE_URL: "https://api.international-robotchallenge.org",
//   REG_LINK:
//     "https://registration.international-robotchallenge.org?automaticLogin=true",
//   APP_ENV: "production",
//   APP_NAME: "Robot Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#7c0707",
//   SECONDARY_COLOR: "#fff",
// };

// Wedo Development Config
// const config = {
//   API_BASE_URL: "https://apistaging.wedochallenge.org",
//   REG_LINK: "https://registrationstaging.wedochallenge.org?automaticLogin=true",
//   APP_ENV: "development",
//   APP_NAME: "Wedo Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#c11a83",
//   SECONDARY_COLOR: "#fff",
// };

// Robot Production Config
// const config = {
//   API_BASE_URL: "https://api.wedochallenge.org",
//   REG_LINK: "https://registration.wedochallenge.org?automaticLogin=true",
//   APP_ENV: "production",
//   APP_NAME: "Wedo Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#c11a83",
//   SECONDARY_COLOR: "#fff",
// };

// Code Development Config
// const config = {
//   API_BASE_URL: "https://apistaging.codechallenge-championship.org",
//   REG_LINK:
//     "https://registrationstaging.codechallenge-championship.org?automaticLogin=true",
//   APP_ENV: "development",
//   APP_NAME: "Code Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#6a0505",
//   SECONDARY_COLOR: "#fff",
// };

// Code Production Config
// const config = {
//   API_BASE_URL: "https://api.codechallenge-championship.org",
//   REG_LINK:
//     "https://registration.codechallenge-championship.org?automaticLogin=true",
//   APP_ENV: "production",
//   APP_NAME: "Code Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#6a0505",
//   SECONDARY_COLOR: "#fff",
// };

export default config;
